<template>
  <div>
    <div class="more--actions">
      <div>
        <v-menu offset-y offset-x content-class="more--actions-container">
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </div>
          </template>
          <div
            class="single--button"
            @click="activateHandler"
            v-if="category.id === 1 || category.id === 0"
          >
            {{ activated ? $t('general.btn.deactivate') : $t('general.btn.activate') }}
          </div>
          <div
            class="single--button"
            @click="repostHandler"
            v-if="category.id === 0 || category.id === 2 || category.id === 3 || category.id === 4"
          >
            {{ $t('general.btn.repost') }}
          </div>
          <div class="single--button" @click="scheduleRepostHandler" v-if="category.id === 0">
            {{ $t('general.btn.scheduleRepost') }}
          </div>
          <div
            v-if="category.id === 0 && enableRecommendedListing"
            class="single--button"
            @click="recommendedListingHandler"
          >
            {{ $t('general.btn.recommendedListing') }}
          </div>
          <div class="single--button" @click="goToEdit">
            {{ $t('general.btn.edit') }}
          </div>
          <div
            class="single--button"
            v-if="category.id === 0 || category.id === 2"
            @click="markOccupiedHandler"
          >
            {{ listing.listing_type === 'S' ? 'Tandai Terjual' : 'Tandai Tersewa' }}
          </div>
          <div v-if="category.id !== 0" class="single--button" @click="deleteHandler">
            {{ $t('general.btn.delete') }}
          </div>
          <div v-if="hasAgentNotes" class="single--button" @click="viewAgentNotes">
            {{ $t('listing.viewAgentNotes') }}
          </div>
        </v-menu>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'more-actions',
  props: ['listing'],
  components: {},
  computed: {
    ...mapState({
      category: (state) => state.listing.category,
      enableRecommendedListing: (state) => state.global.enableRecommendedListing,
    }),
    activated() {
      return this.category.id === 0;
    },
    editHref() {
      return `/listing/edit/${this.listing.uuid}`;
    },
    isRecommendedListing() {
      return (
        this.listing?.boost_status === 'ACTIVE_RECOMMENDED' ||
        this.listing?.boost_status === 'UPCOMING_RECOMMENDED'
      );
    },
    agentNotes() {
      return typeof this.listing?.internal_notes === 'string'
        ? this.listing.internal_notes.trim()
        : '';
    },
    hasAgentNotes() {
      return this.agentNotes.length > 0;
    },
  },
  methods: {
    viewAgentNotes() {
      this.$modal.show('agent-notes-modal', {
        notes: this.agentNotes,
        listingTitle: this.listing?.title || '',
      });
    },
    goToEdit() {
      this.$router.push(this.editHref);
    },
    activateHandler() {
      if (this.activated) {
        console.log('DEACTIVATE!');
        this.deactivate();
      } else {
        console.log('ACTIVATE!');
        this.$modal.show('activate-listing-modal', {
          submitAction: this.activate,
        });
      }
    },
    async activate() {
      try {
        const success = await this.$store.dispatch('listing/activate', this.listing.uuid);
        if (success) {
          await this.$swal(
            this.$i18n.t('general.success'),
            this.$i18n.t('listing.modal.activate.success'),
            'success',
          );
          this.$emit('actionDone');
        }
      } catch (e) {
        console.log('ERROR ACTIVATE LISTING: ', e);
      }
    },
    repostHandler() {
      this.$modal.show('repost-listing-modal', {
        submitAction: this.repost,
      });
    },
    async repost() {
      try {
        const success = await this.$store.dispatch('listing/repost', this.listing.uuid);
        if (success) {
          await this.$swal(
            this.$i18n.t('general.success'),
            this.$i18n.t('listing.modal.repost.success'),
            'success',
          );
          this.$emit('actionDone');
        }
      } catch (e) {
        console.log('ERROR ACTIVATE LISTING: ', e);
        // this.$swal({
        //   title: this.$i18n.t('listing.modal.repost.failedT'),
        //   text: this.$i18n.t('listing.modal.repost.failedM'),
        //   type: 'error',
        //   confirmButtonColor: '#3085d6',
        //   confirmButtonText: this.$i18n.t('general.ok'),
        //   allowOutsideClick: false,
        // });
      }
    },
    scheduleRepostHandler() {
      this.$modal.show('schedule-repost-listing-modal', {
        submitAction: this.scheduleRepost,
        listingUuid: this.listing ? this.listing.uuid : null,
      });
    },
    async scheduleRepost() {
      console.log('AYO SCHEDULE REPOST!');
      try {
        const success = await this.$store.dispatch(
          'listing/scheduleRepost',
          this.listing ? this.listing.uuid : null,
        );
        if (success) {
          await this.$swal(
            this.$i18n.t('general.success'),
            this.$i18n.t('listing.modal.scheduleRepost.success'),
            'success',
          );
          this.$emit('actionDone');
        }
      } catch (e) {
        console.log('ERROR SCHEDULE REPOST: ', e);
      }
    },
    recommendedListingHandler() {
      this.$modal.show('recommended-listing-modal', {
        submitAction: this.setRecommendedListing,
        listingUuid: this.listing ? this.listing.uuid : null,
      });
    },
    async setRecommendedListing() {
      console.log('AYO SET RECOMMENDED LISTING!', this.listing?.uuid);
      try {
        const success = await this.$store.dispatch(
          'recommendedListing/purchase',
          this.listing ? this.listing.uuid : null,
        );
        if (success) {
          await this.$swal(
            this.$i18n.t('general.success'),
            this.$i18n.t('listing.modal.recommendedListing.success'),
            'success',
          );
          this.$emit('actionDone', 'recommendedListing');
        }
      } catch (e) {
        console.log('ERROR SET RECOMMENDED LISTING: ', e);
      }
    },
    async deactivate() {
      try {
        const confirmed = await this.confirmRecommendedListingAction('deactivate');
        if (!confirmed) {
          return;
        }

        const success = await this.$store.dispatch('listing/deactivate', this.listing.uuid);
        if (success) {
          await this.$swal(
            this.$i18n.t('general.success'),
            this.$i18n.t('listing.modal.deactivate.success'),
            'success',
          );
          this.$emit('actionDone');
        }
      } catch (e) {
        console.log('ERROR DEACTIVATE LISTING: ', e);
      }
    },
    deleteHandler() {
      this.$swal({
        title: this.$i18n.t('listing.modal.delete.title'),
        text: this.$i18n.t('listing.modal.delete.message'),
        type: 'error',
        showCancelButton: true,
        confirmButtonText: this.$i18n.t('general.yes'),
        cancelButtonText: this.$i18n.t('general.cancel'),
        allowOutsideClick: false,
      }).then((result) => {
        if (result.value) {
          this.delete();
        }
      });
    },
    async delete() {
      try {
        const success = await this.$store.dispatch('listing/deleteListing', this.listing.uuid);
        if (success) {
          await this.$swal(
            this.$i18n.t('general.success'),
            this.$i18n.t('listing.modal.delete.success'),
            'success',
          );
          this.$emit('actionDone');
        }
      } catch (e) {
        // this.$swal({
        //   title: this.$i18n.t('listing.modal.delete.failedT'),
        //   text: this.$i18n.t('listing.modal.delete.failedM'),
        //   type: 'error',
        //   // showCancelButton: true,
        //   confirmButtonColor: '#3085d6',
        //   // cancelButtonColor: '#d33',
        //   confirmButtonText: this.$i18n.t('general.ok'),
        //   allowOutsideClick: false,
        // });
      }
    },
    markOccupiedHandler() {
      const isSell = this.listing?.listing_type === 'S';

      this.confirmRecommendedListingAction(isSell ? 'sold' : 'rented').then((confirmed) => {
        if (confirmed) {
          this.markOccupied();
        }
      });
    },
    async confirmRecommendedListingAction(action) {
      const labels = {
        deactivate: {
          cta: 'Deaktivasi',
          warningAction: 'Melakukan deaktivasi',
          finalAction: 'melakukan deaktivasi',
          title: this.$i18n.t('listing.modal.deactivate.title'),
        },
        sold: {
          cta: 'Tandai Terjual',
          warningAction: 'Mengubah status terjual',
          finalAction: 'mengubah status terjual',
          title: 'Konfirmasi Tandai Terjual',
        },
        rented: {
          cta: 'Tandai Tersewa',
          warningAction: 'Mengubah status tersewa',
          finalAction: 'mengubah status tersewa',
          title: 'Konfirmasi Tandai Tersewa',
        },
      };
      const config = labels[action];

      if (!this.isRecommendedListing) {
        const result = await this.$swal({
          title: config.title,
          html: this.buildConfirmationHtml([
            action === 'deactivate'
              ? this.$i18n.t('listing.modal.deactivate.message')
              : `Apakah Anda yakin ingin menandai listing ini sebagai ${config.cta.toLowerCase()}?`,
          ]),
          type: action === 'deactivate' ? 'error' : 'warning',
          showCancelButton: true,
          confirmButtonText: this.$i18n.t('general.yes'),
          cancelButtonText: this.$i18n.t('general.cancel'),
          allowOutsideClick: false,
        });
        return Boolean(result.value);
      }

      const warning = await this.$swal({
        title: 'Listing Rekomendasi Aktif',
        html: this.buildConfirmationHtml([
          'Listing ini terdaftar sebagai Listing Rekomendasi.',
          `${config.warningAction} listing akan menyebabkan status listing rekomendasi terhapus.`,
          'Anda dapat memindahkan status Listing Rekomendasi ke listing lain.',
        ]),
        type: 'warning',
        customClass: 'recommended-listing-action-swal',
        showCancelButton: true,
        showCloseButton: true,
        buttonsStyling: false,
        confirmButtonText: `Tetap ${config.cta}`,
        cancelButtonText: 'Ubah Listing Rekomendasi',
        allowOutsideClick: false,
        allowEscapeKey: false,
        onOpen: (popup) => this.styleRecommendedListingSwal(popup),
      });

      if (!warning.value) {
        if (warning.dismiss === 'cancel') {
          this.$router.push('/recommended-listing');
        }
        return false;
      }

      const finalConfirmation = await this.$swal({
        title: config.title,
        html: this.buildConfirmationHtml([
          `Apakah Anda yakin ${config.finalAction}?`,
          `Fitur Listing Rekomendasi akan hangus setelah ${config.finalAction}.`,
        ]),
        type: 'warning',
        customClass: 'recommended-listing-action-swal recommended-listing-action-swal-final',
        showCancelButton: true,
        showCloseButton: true,
        buttonsStyling: false,
        confirmButtonText: 'Iya',
        cancelButtonText: 'Batal',
        allowOutsideClick: false,
        allowEscapeKey: false,
        onOpen: (popup) => this.styleRecommendedListingSwal(popup),
      });

      return Boolean(finalConfirmation.value);
    },
    buildConfirmationHtml(sentences) {
      return `<div class="listing-action-confirmation-copy">${sentences
        .filter(Boolean)
        .map((sentence) => `<p>${sentence}</p>`)
        .join('')}</div>`;
    },
    styleRecommendedListingSwal(popup) {
      const close = popup.querySelector('.swal2-close');
      const icon = popup.querySelector('.swal2-icon');
      const title = popup.querySelector('.swal2-title');
      const content = popup.querySelector('.swal2-content');
      const actions = popup.querySelector('.swal2-actions');
      const confirm = popup.querySelector('.swal2-confirm');
      const cancel = popup.querySelector('.swal2-cancel');
      const isMobile = window.matchMedia('(max-width: 600px)').matches;
      const setStyles = (element, styles) => {
        if (!element) {
          return;
        }

        Object.keys(styles).forEach((key) => {
          element.style.setProperty(key, styles[key], 'important');
        });
      };

      popup.querySelectorAll('*').forEach((element) => {
        element.style.setProperty('font-family', 'Poppins, sans-serif', 'important');
      });

      setStyles(popup, {
        width: isMobile ? 'calc(100% - 32px)' : '520px',
        padding: isMobile ? '28px 18px 20px' : '30px 30px 26px',
        border: '1px solid rgba(200, 25, 25, 0.1)',
        'border-radius': '18px',
        'box-shadow': '0 22px 70px rgba(24, 24, 27, 0.16)',
        'font-family': 'Poppins, sans-serif',
      });

      setStyles(close, {
        top: '14px',
        right: '14px',
        width: '34px',
        height: '34px',
        border: '1px solid #e4e4e7',
        'border-radius': '50%',
        color: '#71717a',
        background: '#fafafa',
        'font-size': '25px',
        'line-height': '34px',
      });

      setStyles(icon, {
        margin: '4px auto 18px',
      });

      setStyles(title, {
        margin: '0 0 10px',
        padding: isMobile ? '0 30px' : '0 22px',
        color: '#18181b',
        'font-family': 'Poppins-SemiBold, Poppins, sans-serif',
        'font-size': isMobile ? '19px' : '24px',
        'line-height': '1.35',
      });

      setStyles(content, {
        'max-width': '430px',
        margin: '0 auto',
        color: '#52525b',
        'font-family': 'Poppins, sans-serif',
        'font-size': isMobile ? '13px' : '15px',
        'font-weight': '400',
        'line-height': '1.7',
      });

      popup.querySelectorAll('.listing-action-confirmation-copy p').forEach((paragraph) => {
        setStyles(paragraph, {
          margin: '0 0 10px',
          color: '#52525b',
          'font-family': 'Poppins, sans-serif',
          'font-size': isMobile ? '13px' : '15px',
          'line-height': '1.65',
        });
      });

      const lastParagraph = popup.querySelector('.listing-action-confirmation-copy p:last-child');
      setStyles(lastParagraph, {
        margin: '0',
      });

      setStyles(actions, {
        display: 'flex',
        width: '100%',
        'justify-content': 'space-between',
        'align-items': 'stretch',
        'margin-top': '28px',
        gap: isMobile ? '10px' : '12px',
      });

      [confirm, cancel].forEach((button) => {
        setStyles(button, {
          'min-height': '44px',
          'min-width': '0',
          padding: '0 18px',
          'border-radius': '12px',
          'font-family': 'Poppins-SemiBold, Poppins, sans-serif',
          'font-size': isMobile ? '13px' : '14px',
          'font-weight': '600',
          'line-height': '1.25',
          'white-space': isMobile ? 'normal' : 'nowrap',
          margin: '0',
        });
      });

      setStyles(cancel, {
        order: '1',
        flex: cancel && cancel.textContent.includes('Listing') ? '1.22 1 0' : '1 1 0',
        color: '#c81919',
        background: '#fff5f5',
        border: '1px solid rgba(200, 25, 25, 0.28)',
      });

      setStyles(confirm, {
        order: '2',
        flex: cancel && cancel.textContent.includes('Listing') ? '0.88 1 0' : '1 1 0',
        color: '#ffffff',
        background: '#c81919',
        border: '1px solid #c81919',
      });
    },
    async markOccupied() {
      try {
        const isSell = this.listing?.listing_type === 'S';
        const actionText = isSell ? 'Terjual' : 'Tersewa';
        const success = await this.$store.dispatch('listing/setOccupied', this.listing.uuid);
        if (success) {
          await this.$swal(
            this.$i18n.t('general.success'),
            `Listing berhasil ditandai sebagai ${actionText.toLowerCase()}.`,
            'success',
          );
          this.$emit('actionDone');
        }
      } catch (e) {
        // this.$swal({
        //   title: this.$i18n.t('listing.modal.delete.failedT'),
        //   text: this.$i18n.t('listing.modal.delete.failedM'),
        //   type: 'error',
        //   // showCancelButton: true,
        //   confirmButtonColor: '#3085d6',
        //   // cancelButtonColor: '#d33',
        //   confirmButtonText: this.$i18n.t('general.ok'),
        //   allowOutsideClick: false,
        // });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/utils/variables';
.more--actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
  margin-right: -8px;

  .v-icon {
    font-size: $font-dl;
    @media #{$phones} {
      font-size: $font-xxl;
    }
  }
}

.single--button {
  width: 100%;
  padding: 8px 20px;
  cursor: pointer;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }

  a {
    display: block;
    width: 100%;
    height: 100%;
    text-decoration: none;
    color: inherit;
  }
}
</style>
